import React from 'react';
import Breadcrumb from '@/shared/components/Breadcrumb';

interface PageHeaderProps {
  title?: string;
  subtitle?: string;
  chip?: string;
  chipClasses?: string;
  breadcrumbs?: {
    label: string;
    url?: string;
    tooltip?: string;
  }[];
  paddingClasses?:string;
  actions?: React.ReactNode;
  centerTitle?: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, chip, chipClasses, breadcrumbs, actions, centerTitle, paddingClasses }) => {
  return (
    <div className={`bg-surface ${title || subtitle? 'h-[152px] border-b':'' } ${paddingClasses || 'px-8 py-6'} flex items-baseline justify-between  border-sidebarHeaderBorder`} data-testid="page-header-container">
      <div className={centerTitle ? "w-full" : ""}>
        {breadcrumbs && (
          <div className={centerTitle ? 'flex justify-center' : ''} data-testid="breadcrumb-container">
            <Breadcrumb breadcrumbs={breadcrumbs} />
          </div>
        )}
        {title || subtitle ? (
          <div className={centerTitle ? "text-center" : ""}>
            {title && (
              <div className={`flex items-center gap-3 ${centerTitle ? "justify-center" : ""}`}>
                {title && <h1 className="text-2xl font-medium text-text">{title}</h1>}
                {chip && (
                  <div className={`inline-flex h-6 items-center rounded px-3 text-sm font-normal text-text-muted bg-surface-alt border border-border ${chipClasses || ''}`}>
                    {chip}
                  </div>
                )}
              </div>
            )}
            {subtitle && <p className="text-base text-resetButton">{subtitle}</p>}
          </div>
        ) : null}
      </div>
      <div className="flex items-center space-x-3">{actions}</div>
    </div>
  );
};

export default PageHeader;